import * as React from 'react';
import { ArrowBack, AutoAwesomeMosaic, Call, GridOn, Web } from "@mui/icons-material";
import { Alert, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover, Snackbar, SvgIcon, Tooltip } from "@mui/material";
import Service from '../../../util/Service';
import MenuIcon from '@mui/icons-material/Menu';
import EventIcon from '@mui/icons-material/Event';
import { IB } from '../../page/portal/setting/SettingPanel';

export default function TemplatePopover(props) {
    const { onSelect, code, refDiv, refreshEditor, element, staticOnly } = props;
    const [showModelo, setShowModelo] = React.useState('main');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [clonedContent, setClonedContent] = React.useState(null);
    const [selectedContent, setSelectedContent] = React.useState(null);
    const [anchorNode, setAnchorNode] = React.useState(null);
    const [baseName, setBaseName] = React.useState(null);
    const [openDialogApi, setOpenDialogApi] = React.useState(false);
    const [openDialogSlide, setOpenDialogSlide] = React.useState(false);
    const [paginas, setPaginas] = React.useState();
    const [msg, setMsg] = React.useState();
    const [openSnack, setOpenSnack] = React.useState(false);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    React.useEffect(() => {
        if (open) {
            const s = window.getSelection();
            if (s.rangeCount > 0 && checkValidEditor()) {
                const range = s.getRangeAt(0);//s.baseNode;
                const cc = range.startContainer;//.cloneContents(); //extractContents();      
                setClonedContent(cc);
            }
        }
    }, [open]);

    const checkValidEditor = () => {
        const s = window.getSelection();
        if (s.rangeCount > 0) {
            const range = s.getRangeAt(0);//s.baseNode;
            const cc = range.startContainer;//.cloneContents(); //extractContents();      
            const pai = cc.parentNode;
            return (pai.id === "very2Editor")
        }
        return false;
    }
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setMsg();
        setOpenSnack(false);
    };
    const handleClick = (event) => {
        const s = window.getSelection();

        if (s.rangeCount === 0) {
            return false;
        }
        const range = s.getRangeAt(0);
        setBaseName(s.baseNode.nodeName);
        let el = range.commonAncestorContainer;
        setAnchorNode(s.anchorNode.parentNode);

        setSelectedContent(el)
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleContatoPage = () => {
        Service.GET("/api/security/model/contatoPagina").then(r => {
            if (r.success) {
                console.log(r)
                // refDiv.current.innerHTML = r.dado;
                const div = document.createElement("div");
                div.innerHTML = r.html;
                const st = refDiv.current.querySelector("style");
                if (st) {
                    st.appendChild(r.css)
                } else {
                    const s = document.createElement("style");
                    s.textContent = r.css;
                    refDiv.current.prepend(s);
                }
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        });
    }
    const handleModeloTabela=()=>{
        Service.GET("/api/security/model/tabelaPagina").then(r => {
            if (r.success) {
                console.log(r)
                // refDiv.current.innerHTML = r.dado;
                const div = document.createElement("div");
                div.innerHTML = r.html;
                const st = refDiv.current.querySelector("style");
                if (st) {
                    st.appendChild(r.css)
                } else {
                    const s = document.createElement("style");
                    s.textContent = r.css;
                    refDiv.current.prepend(s);
                }
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        });
    }
    // const handleRemontaMenu=()=> {
    //     const div = document.createElement("div");
    //     div.innerHTML = 'Remonta menu'
    //     refDiv.current.appendChild(div);
    //     handleClose();
    //     refreshEditor();
    // }
    const handleCalendarioMensal=()=>{
        Service.GET("/api/security/model/calendarioMensal").then(r => {
            if (r.success) {
                console.log(r)
                // refDiv.current.innerHTML = r.dado;
                const div = document.createElement("div");
                div.innerHTML = r.html;
                const js = refDiv.current.querySelector("script");
                if( js ){
                    var jsOld =js.textContent;
                    jsOld +="\n\n"+r.js 
                    js.textContent = jsOld;
                }else{
                    const s = document.createElement("script");
                    s.setAttribute('execute-react', true);
                    s.textContent = r.js;
                    refDiv.current.prepend(s);
                }
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        })
    }
    const handleSimplePage=()=>{
        Service.GET("/api/security/model/simplePage").then(r => {
            if (r.success) {
                console.log(r)
                // refDiv.current.innerHTML = r.dado;
                const div = document.createElement("div");
                div.innerHTML = r.html;
                // const st = refDiv.current.querySelector("style");
                // if (st) {
                //     st.textContent += r.css;
                // } else {
                //     const s = document.createElement("style");
                //     s.textContent = r.css;
                //     refDiv.current.prepend(s);
                // }
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        })
    }
    const handleErroPage=()=>{
        Service.GET("/api/security/model/erroPage").then(r => {
            if (r.success) {
                console.log(r)
                const div = document.createElement("div");
                div.innerHTML = r.html;
                
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        })
    }

    const handlerPortalPage = () => {
         Service.GET("/api/security/model/portalPage").then(r => {
            if (r.success) {
                console.log(r)
                // refDiv.current.innerHTML = r.dado;
                const div = document.createElement("div");
                div.innerHTML = r.html;
                // const st = refDiv.current.querySelector("style");
                // if (st) {
                //     st.textContent += r.css;
                // } else {
                //     const s = document.createElement("style");
                //     s.textContent = r.css;
                //     refDiv.current.prepend(s);
                // }
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        })
    }
    const handleRodapePage = () => {
        Service.GET("/api/security/model/rodapePagina").then(r => {
            if (r.success) {
                console.log(r)
                // refDiv.current.innerHTML = r.dado;
                const div = document.createElement("div");
                div.innerHTML = r.html;
                const st = refDiv.current.querySelector("style");
                if (st) {
                    st.textContent += r.css;
                } else {
                    const s = document.createElement("style");
                    s.textContent = r.css;
                    refDiv.current.prepend(s);
                }
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        })
    }
    const handleTabelaEscala = () => {
        if (!checkRange()) {
            setOpenSnack(true);
            setMsg("Escolha onde colocar a tabela ");
            handleClose();
            return;
        }
        const htmlOld = refDiv.current.innerHTML;
        const remove = document.createElement('p');
        remove.setAttribute("id", "paraRemover");
        remove.textContent = "---";
        if (clonedContent) {
            clonedContent.replaceWith(remove);
        } else {
            if (baseName === '#text') {
                // const txt = anchorNode.textContent;
                // let html = r.dado;
                // html = html.replace( "Sumário", txt);
                // anchorNode.innerHTML = html;
                anchorNode.appendChild(remove);
            } else {
                selectedContent.appendChild(remove);
            }
        }

        // let html = '';
        // const el = document.getElementById("very2Editor");
        // if (!el) {
        //     html = refDiv.current.innerHTML;
        // } else {
        //     html = el.innerHTML;
        // }
        const html = refDiv.current.innerHTML;
        const dado = {
            code: html,
        }
        Service.POST("/api/security/model/tabelaEscala", dado).then(r => {
            if (r.success) {
                refDiv.current.innerHTML = r.dado;
                handleClose();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }
        })
    }
    function rangeRecursivo(comp) {

        if (!comp) return false;
        if (comp.id === 'very2Editor') {
            return true;
        } else {
            if (comp.tagName === 'BODY') return false;
            return rangeRecursivo(comp.parentNode);
        }
        return false;
    }
    function checkRange() {
        if (clonedContent) return true;

        return rangeRecursivo(selectedContent);
    }
    const handleLista = () => {
        if (!checkRange()) {
            setOpenSnack(true);
            setMsg("Escolha onde colocar a lista identada");
            handleClose();
            return;
        }
        const dado = {}
        Service.POST("/api/security/model/listaUL", dado).then(r => {
            if (r.success) {
                selectedContent.innerHTML = r.dado;
                handleClose();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                // refDiv.current.innerHTML = htmlOld;
            }
        })
    }
    const handleMontaCode = () => {
        if (!checkRange()) {
            setOpenSnack(true);
            setMsg("Escolha onde colocar o codigo ");
            handleClose();
            return;
        }
        const htmlOld = refDiv.current.innerHTML;
        if (clonedContent) {
            const remove = document.createElement('p');
            remove.setAttribute("id", "paraRemover");
            remove.textContent = "---";
            clonedContent.replaceWith(remove);
        }

        let html = '';
        const el = document.getElementById("very2Editor");
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }
        const dado = {
            code: html,
        }
        Service.POST("/api/security/model/codigo", dado).then(r => {
            if (r.success) {
                if (refDiv.current.textContent.includes("---")) {
                    refDiv.current.innerHTML = r.dado;
                } else {
                    if (baseName === '#text') {

                        const txt = anchorNode.textContent;
                        let html = r.dado;
                        const div = document.createElement('div');
                        div.innerHTML = html;
                        const el = div.querySelector("code");
                        el.textContent = txt.trim();
                        //html = html.replace( "Sumário", txt);
                        anchorNode.innerHTML = div.innerHTML;
                    } else {
                        selectedContent.innerHTML = r.dado;
                    }
                }
                handleClose();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }
        })
    }
    const handleMontaForm = () => {
        if (!checkRange()) {
            setOpenSnack(true);
            setMsg("Escolha onde colocar o formulário ");
            handleClose();
            return;
        }
        const htmlOld = refDiv.current.innerHTML;
        const remove = document.createElement('p');
        remove.setAttribute("id", "paraRemover");
        remove.textContent = "---";
        if (clonedContent) {
            clonedContent.replaceWith(remove);
        } else {
            if (baseName === '#text') {
                anchorNode.appendChild(remove);
            } else {
                selectedContent.appendChild(remove);
            }
        }
        const html = refDiv.current.innerHTML;
        const dado = {
            code: html,
        }
        Service.POST("/api/security/model/formulario", dado).then(r => {
            if (r.success) {
                refDiv.current.innerHTML = r.dado;
                handleClose();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }
        })
    }
    const handleClickOpeChat = () => {
        let html = '';
        const el = document.getElementById("very2Editor");
        if (!el) {
            html = refDiv.current.lastElementChild.innerHTML;
        } else {
            html = el.innerHTML;
        }

        const dado = {
            code: html,
        }
        Service.POST("/api/security/model/addChatCode", dado).then(r => {
            if (r.success) {
                const div = document.createElement('div');
                div.innerHTML = r.dado
                refDiv.current.appendChild(div);
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
            }
        })
    }
    const handleClickOpenDialog = () => {
        let htmlOld = null;
        if (clonedContent) {
            const remove = document.createElement('p');
            remove.setAttribute("id", "paraRemover");
            remove.textContent = "---";
            clonedContent.replaceWith(remove);
            htmlOld = refDiv.current.innerHTML;
        } else {
            htmlOld = refDiv.current.innerHTML;
        }
        let html = '';
        const el = document.getElementById("very2Editor");
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }

        const dado = {
            code: html,
        }
        Service.POST("/api/security/model/addDialogCode", dado).then(r => {
            if (r.success) {
                refDiv.current.innerHTML = r.dado;
                handleClose();
                refreshEditor();
            } else {
                setMsg(r.msg);
                setOpenSnack(true);
                if (htmlOld) { //deu algum erro volta backup se existe
                    refDiv.current.innerHTML = htmlOld;
                }
            }
        })
    }
    const handleMontaTabBar=()=>{
        if (!checkRange()) {
            setOpenSnack(true);
            setMsg("Escolha onde colocar o tabBar ");
            handleClose();
            return;
        }
        const htmlOld = refDiv.current.innerHTML;
        if (clonedContent) {
            const remove = document.createElement('p');
            remove.setAttribute("id", "paraRemover");
            remove.textContent = "---";
            clonedContent.replaceWith(remove);
        }
        let html = '';
        const el = document.getElementById("very2Editor");
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }
        const dado = {
            code: html,
        }
        Service.POST("/api/security/model/tabBar", dado).then(r => {
            if (r.success) {
                if (refDiv.current.textContent.includes("---")) {
                    refDiv.current.innerHTML = r.dado;
                } else {
                    if (baseName === '#text') {
                        console.log( baseName);
                        const txt = anchorNode.textContent;
                        let html = r.dado;
                        html = html.replace("Sumário", txt);
                        anchorNode.innerHTML = html;
                    } else {
                        selectedContent.innerHTML = r.dado;
                    }
                }
                handleClose();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }
        })
    }
    const handleMontaAccordeon = () => {
        if (!checkRange()) {
            setOpenSnack(true);
            setMsg("Escolha onde colocar o acordeon ");
            handleClose();
            return;
        }
        const htmlOld = refDiv.current.innerHTML;
        if (clonedContent) {
            const remove = document.createElement('p');
            remove.setAttribute("id", "paraRemover");
            remove.textContent = "---";
            clonedContent.replaceWith(remove);
        }
        let html = '';
        const el = document.getElementById("very2Editor");
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }
        const dado = {
            code: html,
        }
        Service.POST("/api/security/model/accordeon", dado).then(r => {
            if (r.success) {
                if (refDiv.current.textContent.includes("---")) {
                    refDiv.current.innerHTML = r.dado;
                } else {
                    if (baseName === '#text') {
                        const txt = anchorNode.textContent;
                        let html = r.dado;
                        html = html.replace("Sumário", txt);
                        anchorNode.innerHTML = html;
                    } else {
                        selectedContent.innerHTML = r.dado;
                    }
                }
                handleClose();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }
        })
    }
    const paginaList = () => {
        if (showModelo !== 'pagina') return;
        return (
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense={true} disablePadding>
                <ListItem sx={{ cursor: 'pointer' }} onClick={() => setShowModelo('main')} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <SvgIcon sx={{ height: 24, width: 24 }}>
                                    <ArrowBack />
                                </SvgIcon>
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Pagina" secondary="Modelo de pagina" />
                    </ListItemButton>
                </ListItem>

                <ListItem sx={{ cursor: 'pointer' }} onClick={handlerPortalPage} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <SvgIcon sx={{ height: 24, width: 24 }}>
                                    <Web />
                                </SvgIcon>
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Portal" secondary="Modelo pagina portal" />
                    </ListItemButton>
                </ListItem>
                <ListItem sx={{ cursor: 'pointer' }} onClick={handleErroPage} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                               <img width="18px" height="18px" src="/svg/errorPage.svg"/>
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Página Erro" secondary="Modelo erro" />
                    </ListItemButton>
                </ListItem>
                <ListItem sx={{ cursor: 'pointer' }} onClick={handleSimplePage} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <SvgIcon sx={{ height: 24, width: 24 }}>
                                    <Web />
                                </SvgIcon>
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Página" secondary="Modelo simples" />
                    </ListItemButton>
                </ListItem>

                <ListItem sx={{ cursor: 'pointer' }} onClick={handleContatoPage} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <SvgIcon sx={{ height: 24, width: 24 }}>
                                    <Call />
                                </SvgIcon>
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Contato" secondary="Modelo fale conosco" />
                    </ListItemButton>
                </ListItem>
                <ListItem sx={{ cursor: 'pointer' }} onClick={handleRodapePage} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <img width="24px" height="24px" src="/svg/rodape.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Rodapé" secondary="Modelo rodapé" />
                    </ListItemButton>
                </ListItem>
                {/* <ListItem sx={{ cursor: 'pointer' }} onClick={handleRemontaMenu} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <MenuIcon />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Menu" secondary="Refaz menu" />
                    </ListItemButton>
                </ListItem> */}
                <ListItem sx={{ cursor: 'pointer' }} onClick={handleCalendarioMensal} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <EventIcon />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Calenário" secondary="mensal" />
                    </ListItemButton>
                </ListItem>

                <ListItem sx={{ cursor: 'pointer' }} onClick={handleModeloTabela} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <GridOn />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Tabela" secondary="Modelo de tabela" />
                    </ListItemButton>
                </ListItem>

            </List>
        )
    }
    const mainList = () => {
        if (showModelo !== 'main') return;
        return (
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense={true} disablePadding>
                {(!staticOnly || staticOnly !== true) &&
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => setShowModelo('pagina')} disablePadding>
                        <ListItemButton sx={{ height: 46 }}>
                            <ListItemIcon >
                                <IB size="small">
                                    <img width="24px" height="24px" src="/svg/modeloPagina.svg" />
                                </IB>
                            </ListItemIcon>
                            <ListItemText primary="Pagina" secondary="Modelo de pagina" sx={{ my: 0 }} />
                        </ListItemButton>
                    </ListItem>}

                <ListItem sx={{ cursor: 'pointer' }} onClick={handleTabelaEscala} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <img width="24px" height="24px" src="/svg/tabela.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Tabela" secondary="Modelo de escala" />
                    </ListItemButton>
                </ListItem>

                <ListItem sx={{ cursor: 'pointer' }} onClick={handleLista} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <img width="24px" height="24px" src="/svg/listaUL.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Lista" secondary="Lista Identada" />
                    </ListItemButton>
                </ListItem>
                <ListItem sx={{ cursor: 'pointer' }} onClick={handleMontaCode} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon>
                            <IB size="small">
                                <img width="24px" height="24px" src="/svg/code.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Code" secondary="Modelo de codigo" />
                    </ListItemButton>
                </ListItem>
                <ListItem sx={{ cursor: 'pointer' }} onClick={handleMontaAccordeon} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <img width="24px" height="24px" src="/svg/accordeon.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Accordeon" secondary="Modelo sanfona" />
                    </ListItemButton>
                </ListItem>
                <ListItem sx={{ cursor: 'pointer' }} onClick={handleMontaTabBar} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                            <svg width="24px" height="24px" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enableBackground="new 0 0 52 52">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g>
                                    <path d="M31.6,2H20.4c-0.7,0-1.2,0.6-1.2,1.3v2.5c0,0.7,0.6,1.3,1.2,1.3h11.2c0.7,0,1.2-0.6,1.2-1.3V3.3 C32.9,2.6,32.3,2,31.6,2z"></path> </g> <g> <path d="M48.7,2H37.5c-0.7,0-1.3,0.6-1.3,1.3v2.5c0,0.7,0.6,1.3,1.3,1.3h11.2C49.4,7,50,6.5,50,5.8V3.3 C50,2.6,49.4,2,48.7,2z"></path> </g> <g> <path d="M48.7,10.4H17c-0.7,0-1.3-0.6-1.3-1.3V3.3c0-0.7-0.6-1.3-1.3-1.3H3.3C2.6,2,2,2.6,2,3.3v45.5 C2,49.4,2.6,50,3.3,50h1.7H7h41.7c0.7,0,1.3-0.6,1.3-1.3V11.7C50,11,49.4,10.4,48.7,10.4z">
                                    </path> </g> </g>
                            </svg>
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Tab" secondary="TabBar" />
                    </ListItemButton>
                </ListItem>

                <ListItem sx={{ cursor: 'pointer' }} onClick={handleMontaForm} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <img width="24px" height="24px" src="/svg/form.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Form" secondary="Modelo formulário" />
                    </ListItemButton>
                </ListItem>
                {(!staticOnly || staticOnly !== true) &&
                    <ListItem sx={{ cursor: 'pointer' }} onClick={handleClickOpenDialog} disablePadding>
                        <ListItemButton sx={{ height: 46 }}>
                            <ListItemIcon >
                                <IB size="small">
                                    <img width="24px" height="24px" src="/svg/dialog.svg" />
                                </IB>
                            </ListItemIcon>
                            <ListItemText primary="Dialog" secondary="Tela de Dialogo" />
                        </ListItemButton>
                    </ListItem>}
                {(!staticOnly || staticOnly !== true) &&
                <ListItem sx={{ cursor: 'pointer' }} onClick={handleClickOpeChat} disablePadding>
                    <ListItemButton sx={{ height: 46 }}>
                        <ListItemIcon >
                            <IB size="small">
                                <img width="24px" height="24px" src="/svg/chat.svg" />
                            </IB>
                        </ListItemIcon>
                        <ListItemText primary="Chat" secondary="Conversar" />
                    </ListItemButton>
                </ListItem>}

            </List>
        )
    }

    return (
        <React.Fragment>
            <Tooltip title="Template">
                <IB
                    color={element ? 'primary' : 'secundary'}
                    onClick={handleClick}
                    size="small"
                >
                    <AutoAwesomeMosaic />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {mainList()}
                {paginaList()}
            </Popover>
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </React.Fragment>
    )

}